const sortedArray = array => {
  return array.sort((a, b) => {
    return a.id - b.id;
  });
};

const getFilterUrl = data => {
  const {
    searchType,
    filterValue,
    limit,
    offsetValue
  } = data;
  let url = `/api/reco/criteria?fieldList=${searchType}`;

  if (filterValue) {
    url += `&filter=${filterValue}`;
  }

  url += `&limit=${limit}&offset=${offsetValue}`;
  return url;
};

export { sortedArray, getFilterUrl };